import React from 'react';
import CasinoSportBookModuleLoader from './CasinoSportBookModuleLoader';
import i18n from '@i18n';
import imports from '@/routing/imports';
import Loadable from '@/common/lazy/Loadable';
import IntersectionObserver from '@/ui/IntersectionObserver';

const CasinoSportBookModule = Loadable({
    loader: imports.casinoSportBookModule,
    loading: CasinoSportBookModuleLoader,
    exp: Exp => Exp
});

export const IOLoadableCasinoSportBookModule = () => {
    return (
        <IntersectionObserver>
            {visible =>
                visible ? (
                    <CasinoSportBookModule
                        subText={i18n('menu.actualJackpots')}
                        otherText={i18n('casino.promo.games')}
                    />
                ) : (
                    <CasinoSportBookModuleLoader />
                )
            }
        </IntersectionObserver>
    );
};
